import { isValid, parse } from 'date-fns';

import { DATE_FORMAT } from './formatRange';

export type ParsedDateRange = { from: Date; to: Date | undefined };

const RANGE_SEPARATOR = /\s*[-—–]\s*/;

export const parseDateInput = (text: string, referenceDate: Date = new Date()): Date | undefined => {
  const trimmed = text.trim();

  if (trimmed.length !== DATE_FORMAT.length) {
    return undefined;
  }

  const parsed = parse(trimmed, DATE_FORMAT, referenceDate);

  return isValid(parsed) ? parsed : undefined;
};

export const parseDateRangeInput = (text: string, referenceDate: Date = new Date()): ParsedDateRange | undefined => {
  const [fromText, toText] = text.split(RANGE_SEPARATOR);
  const from = fromText ? parseDateInput(fromText, referenceDate) : undefined;

  if (!from) {
    return undefined;
  }

  if (!toText) {
    return { from, to: undefined };
  }

  const to = parseDateInput(toText, referenceDate);

  if (!to) {
    return undefined;
  }

  return to < from ? { from: to, to: from } : { from, to };
};
